import { API_ENDPOINTS, buildApiUrl } from "../config/api";

export type UserProfile = {
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  created_by: string;
  role: string;
  id_role: string;
  tenant_id: string;
  created_at: string;
  preferences?: {
    language?: string;
    timezone?: string;
    notify_by_email?: boolean;
    notify_by_push?: boolean;
    notify_by_sms?: boolean;
    two_factor?: boolean;
  };
};

type ProfileResponse = {
  status: number;
  message: string;
  data?: UserProfile;
};

export async function fetchUserProfile() {
  const token = localStorage.getItem("access_token");
  if (!token) return null;

  const response = await fetch(buildApiUrl(API_ENDPOINTS.profile), {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error("Nao foi possivel carregar perfil do usuario");
  }

  const json = (await response.json().catch(() => null)) as ProfileResponse | null;
  if (!json?.data) return null;

  return json.data;
}
